var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal modal--domain modal-domain"},[(_vm.isLoading)?_c('div',{staticClass:"modal__loading"},[_c('loading-spinner')],1):_vm._e(),_c('div',{staticClass:"modal-domain__form"},[_c('form-domain',{attrs:{"domain":_vm.domain}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }